// extracted by mini-css-extract-plugin
export default {"baner":"style_baner__aZt4H","bg":"style_bg__fE-7n","content":"style_content__DpDTW"};